import { render, staticRenderFns } from "./AuthorizationBanner.vue?vue&type=template&id=b8e93b84&"
import script from "./AuthorizationBanner.vue?vue&type=script&lang=js&"
export * from "./AuthorizationBanner.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBanner,VBtn,VIcon})
